<template>
    <div>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <button :class="'nav-link' + (activeTab ? ' active' : '')" id="8mesesDiv-tab" data-toggle="tab"
                    data-target="#8mesesDiv" type="button" role="tab" aria-controls="seccionesDiv" aria-selected="false"
                    @click.prevent="activaTab(true)">8 Meses</button>
            </li>
            <li class="nav-item" role="presentation">
                <button :class="'nav-link' + (!activeTab ? ' active' : '')" id="5mesesDiv-tab" data-toggle="tab"
                    data-target="#5mesesDiv" type="button" role="tab" aria-controls="cursoDiv" aria-selected="true"
                    @click.prevent="activaTab(false)">5 Meses</button>
            </li>
        </ul>
        <br>
        <div class="tab-content" id="myTabContent">
            <div :class="'tab-pane fade' + (!activeTab ? ' show active' : '')" id="5mesesDiv" role="tabpanel"
                aria-labelledby="5mesesDiv-tab">
                <div class="row mb-3">
                    <div v-for="(item, index) in items_5_meses" :key="index" class="col-lg-6">
                        <div class="rounded-8 shadow p-3 bootcamp-card">
                            <h4>{{ item.title }}</h4>
                            <div class="text-truncate-5">{{ item.description }} <a v-show="item.link_tarjeta != ''" :href="item.link_tarjeta"
                                    target="_blank" class="descarga_plan">
                                    Descargar plan</a></div>
                            <div class="text-end">
                                <a :href="item.cta" target="_blank" class="btn btn-secondary py-1 text-light"> {{
                                    item.cta_text }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="'tab-pane fade' + (activeTab ? ' show active' : '')" id="8mesesDiv" role="tabpanel"
                aria-labelledby="8mesesDiv-tab">
                <div class="row mb-3">
                    <div v-for="(item, index) in items_8_meses" :key="index" class="col-lg-6">
                        <div class="rounded-8 shadow p-3 bootcamp-card">
                            <h4>{{ item.title }}</h4>
                            <div class="text-truncate-5">{{ item.description }} <a v-show="item.link_tarjeta != ''" :href="item.link_tarjeta" target="_blank" class="descarga_plan"> Descargar plan</a></div>
                            <div class="text-end">
                                <a :href="item.cta" target="_blank" class="btn btn-secondary py-1 text-light"> {{
                                    item.cta_text }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ["get", "headertab"],
    data() {
        return {
            search: "",
            headersTabs: this.headertab,
            url: this.get,
            desserts: [],
            items_5_meses: [],
            items_8_meses: [],
            edit: [],
            destroy: [],
            newBootcamps: { title: "", description: "", cta: "", cta_text: "", link_tarjeta: "" },
            error: [],
            activeTab: true,
            urlDownload: "/files/download"
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            axios.get(this.url).then((res) => {
                this.desserts = res.data;
                this.items_5_meses = this.desserts.filter((el) => el.program_time == '5_meses');
                this.items_8_meses = this.desserts.filter((el) => el.program_time == '8_meses');
            });
        },
        editarBootcamps() {
            let btn = document.getElementById("update");
            let cancel = document.getElementById("closeAdd");
            let modal = document.getElementById("updateModal");
            let bd = document.getElementsByClassName("modal-backdrop");

            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");

            btn.textContent = "Procesando ...";
            axios
                .put(this.url + `/${this.edit.id}`, this.edit)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        btn.textContent = "Actualizar bootcamp";
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        eliminarBootcamps() {
            const response = document.getElementById("response");
            let btn = document.getElementById("delete");
            let cancel = document.getElementById("close");
            let modal = document.getElementById("deleteModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            let succesDeleteBtn = document.getElementById("succesDeleteBtn");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .delete(this.url + "/" + this.destroy.id)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        btn.textContent = "Eliminar bootcamp";
                        succesDeleteBtn.click();
                    }, 500);
                })
                .catch((err) => {
                    console.log(err.error);
                    response.outerText = "Error al eliminar datos";
                    cancel.removeAttribute("disabled");
                    btn.setAttribute("style", "display:none");

                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        btn.removeAttribute("style");
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        window.location.reload();
                    }, 1000);
                });
        },
        agregarBootcamps() {
            let btn = document.getElementById("agregar");
            let cancel = document.getElementById("closeAdd");
            let modal = document.getElementById("addModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .post(this.url, this.newBootcamps)
                .then((res) => {
                    this.newBootcamps = {
                        title: "",
                        description: "",
                        cta: "",
                        cta_text: "",
                        link_tarjeta: "",
                    };
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        btn.textContent = "Agregar bootcamp";
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => { });
        },
        filtrarPorOrden(val) {
            const value = val.target.value;
            axios.get(`${this.url}?filterOrder=${value}`).then((res) => {
                this.desserts = res.data;
                this.items_5_meses = this.desserts.filter((el) => el.program_time == '5_meses');
                this.items_8_meses = this.desserts.filter((el) => el.program_time == '8_meses');
            });
        },
        activaTab(bool) {
            this.activeTab = bool;
        },
    },
};
</script>

<style>.descarga_plan {
    text-decoration: underline;
    font-weight: bold;
}</style>
